import { BRAND } from "../lib/api";
import { CheckCircle2, HeartHandshake, Sparkles } from "lucide-react";

const values = [
  { icon: HeartHandshake, title: "Welcoming & Inclusive", body: "Training that meets learners where they are — friendly, judgment-free, and easy to follow." },
  { icon: Sparkles, title: "Practical & Confidence-building", body: "Hands-on scenarios that build real skills, not just checkboxes on a certification card." },
  { icon: CheckCircle2, title: "Trusted by Local Organizations", body: "Serving childcare centers, schools, churches, healthcare teams, and businesses across PA and NJ." },
];

export default function About() {
  return (
    <div>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <span className="font-script text-3xl text-brand-coral">Our story</span>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-brand-navy tracking-tight mt-2">About KenMarq Safety Training</h1>
          <p className="mt-6 text-slate-600 leading-relaxed text-lg">
            KenMarq Safety Training provides engaging, practical, and confidence-building CPR, First Aid, and safety instruction for individuals, businesses, childcare centers, schools, churches, community organizations, healthcare professionals, and other workplace teams.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Clients may attend a scheduled class at our training location in Bethlehem, Pennsylvania, or request on-site training at their own business or organization. Our goal is to make lifesaving education clear, enjoyable, and easy to understand while helping individuals and organizations meet their training and certification needs.
          </p>
        </div>
        <div className="lg:col-span-6">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/3] shadow-xl">
            <img src={BRAND.aboutImage} alt="Real-life training impact" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-navy/60 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 text-white">
              <div className="font-script text-3xl text-brand-amber">Train Today.</div>
              <div className="font-display text-2xl font-bold">Build a Safer Tomorrow.</div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-surface py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-brand-navy tracking-tight text-center">What guides our teaching</h2>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl border border-slate-200 p-8 hover:shadow-md transition-shadow" data-testid={`about-value-${v.title}`}>
                <v.icon className="h-10 w-10 text-brand-teal" />
                <h3 className="font-display font-bold text-xl text-brand-navy mt-4">{v.title}</h3>
                <p className="mt-2 text-slate-600 leading-relaxed">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
